import { getTextFromHtml } from '@/commonFunctions/utils'
import { DESCRIPTION_MAX_LENGTH, DESCRIPTION_MIN_LENGTH, TITLE_MAX_LENGTH } from '@/constants/Common'
import {
  EVENT_ANNOUCEMENT_DESCRIPTION_MAX,
  EVENT_ANNOUCEMENT_DESCRIPTION_MIN,
  EVENT_ANNOUNCEMENT_TITLE_MAX,
  EVENT_ANNOUNCEMENT_TITLE_REQUIRED,
  EVENT_DESCRIPTION_REQUIRED,
} from '@/constants/MessageConstants'
import * as Yup from 'yup'

const SaveAnnouncementValidationSchema = Yup.object().shape({
  title: Yup.string().required(EVENT_ANNOUNCEMENT_TITLE_REQUIRED).max(TITLE_MAX_LENGTH, EVENT_ANNOUNCEMENT_TITLE_MAX),
  description: Yup.string()
    .required(EVENT_DESCRIPTION_REQUIRED)
    .test(
      'minlength',
      EVENT_ANNOUCEMENT_DESCRIPTION_MIN,
      (desc) => getTextFromHtml(desc).length >= DESCRIPTION_MIN_LENGTH
    )
    .test(
      'maxlength',
      EVENT_ANNOUCEMENT_DESCRIPTION_MAX,
      (desc) => getTextFromHtml(desc).length <= DESCRIPTION_MAX_LENGTH
    ),
})

export default SaveAnnouncementValidationSchema
